import { AccountInfo, BrowserAuthError, ServerError } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { t } from 'i18next';
import { FaMicrosoft } from 'react-icons/fa';
import { useDispatch } from 'react-redux';

import AuthTypesEnum from '../../../enums/authTypes';
import HttpStatus from '../../../enums/httpStatus';
import { loginRequest } from '../../../services/auth/microsoft/authMsConfig';
import { externalLoginApi } from '../../../services/requests';
import { setStatusLoadingLogin, signInSuccess } from '../../../store/modules/auth/actions';
import { AuthResponseData } from '../../../types/auth';
import { frontendNotification } from '../../Notification';
import Btn from '../Btn';

const MicrosoftLoginBtn = () => {
  const dispacth = useDispatch();
  const { instance } = useMsal();

  const signInMicrosoftAction = async () => {
    try {
      dispacth(setStatusLoadingLogin(true));
      const msResponse = await instance.loginPopup(loginRequest);
      // Pegar os dados do usuário e o idToken
      const account: AccountInfo | null = instance.getAllAccounts()[0];
      if (msResponse && account) {
        const res = await externalLoginApi.store({
          'X-Authorization-Type': AuthTypesEnum.MICROSOFT,
          Authorization: msResponse.idToken,
        });
        if (res.status === HttpStatus.OK) {
          const loginDataSuccessful: AuthResponseData = res.data.data;
          dispacth(signInSuccess(loginDataSuccessful));
        } else {
          throw res;
        }
      } else {
        frontendNotification({ message: 'No user account found', type: 'error' });
      }
    } catch (e: unknown) {
      if (e instanceof BrowserAuthError) {
        frontendNotification({ message: e.errorMessage, type: 'error' });
        // eslint-disable-next-line no-console
        console.error(e.errorMessage);
      } else if (e instanceof ServerError) {
        // eslint-disable-next-line no-console
        frontendNotification({ message: e.errorMessage, type: 'error' });
      } else {
        // eslint-disable-next-line no-console
        console.error(e);
      }
      dispacth(setStatusLoadingLogin(false));
    }
  };

  return (
    <Btn
      text={t('signInWithMicrosoft')}
      Icon={FaMicrosoft}
      onClick={signInMicrosoftAction}
      style={{ marginBottom: '2rem' }}
    />
  );
};

export default MicrosoftLoginBtn;
